import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchHighlight, updateHighlight } from "actions/highlight";
import { fetchTags } from "actions/tag";
import { fetchFilterTags } from "actions/filterTag";
import { fetchGroups } from "actions/group";
import { fetchHighlightActions } from "actions/highlightAction";
import { fetchProductCategories } from "actions/productCategory";
import {
  uploadImage,
  setUploadedImagePreview,
  removeUploadedImage
} from "actions/image";
import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import dateUtil from "utils/date";

import Form from "pages/Highlights/Form";

class HighlightEdit extends Component {
  componentWillUnmount() {
    this.props.removeUploadedImage("cover");
    this.props.removeUploadedImage("logo");
  }

  componentDidMount() {
    const {
      activeCompany,
      match,
      fetchHighlight,
      fetchHighlightActions
    } = this.props;
    const company_url = activeCompany.url;
    const id = match.params.highlightId;
    fetchHighlight(id, { company_url });
    fetchHighlightActions({ company_url });
  }

  shapedDefaultValuesStructure() {
    const {
      expired_at,
      released_at,
      tags,
      groups,
      filter_tags,
      product_categories,
      attachments,
      ...rest
    } = this.props.highlight.data;
    return Object.assign(
      {},
      {
        ...rest,
        released_at: dateUtil.phpFormatToJS(released_at),
        expired_at: dateUtil.phpFormatToJS(expired_at),
        attachments: attachments,
        tags: tags ? tags.map(({ name }) => name) : [],
        productCategories: product_categories || [],
        filterTags: filter_tags ? filter_tags.map(({ name }) => name) : [],
        groups: groups ? groups.map(({ name }) => name) : []
      }
    );
  }

  updateHighlight(id, data) {
    const {
      toggleNotification,
      activeCompany,
      toggleFullPageSpinner,
      updateHighlight,
      history
    } = this.props;

    toggleFullPageSpinner(true);

    updateHighlight(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated Highlight Success",
          infoClassName: "is-success"
        });
        history.push(`/${activeCompany.url}/highlights`);
      })
      .catch(e => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger"
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = data => {
    const { activeCompany, match } = this.props;
    const id = match.params.highlightId;

    data = Object.assign({}, data, { company_url: activeCompany.url });
    this.updateHighlight(id, data);
  };

  render() {
    const {
      uploadedImagesPreview,
      uploadedImagesPercentage,
      uploadedImages,
      removeUploadedImage,
      uploadImage,
      setUploadedImagePreview,
      fetchProductCategories,
      productCategories,
      highlight,
      highlightActions,
      tags,
      groups,
      filterTags,
      fetchTags,
      fetchGroups,
      fetchFilterTags,
      activeCompany
    } = this.props;

    if (highlight.loading || highlightActions.loading) {
      return "loading";
    }

    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        uploadImage={uploadImage}
        uploadedImages={uploadedImages}
        setUploadedImagePreview={setUploadedImagePreview}
        removeUploadedImage={removeUploadedImage}
        uploadedImagesPreview={uploadedImagesPreview}
        uploadedImagesPercentage={uploadedImagesPercentage}
        defaultValues={defaultValues}
        fetchProductCategories={fetchProductCategories}
        productCategories={productCategories}
        tags={tags}
        groups={groups}
        filterTags={filterTags}
        fetchTags={fetchTags}
        fetchGroups={fetchGroups}
        fetchFilterTags={fetchFilterTags}
        activeCompany={activeCompany}
        highlightActions={highlightActions}
      />
    );
  }
}

const mapStateToProps = ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  productCategories,
  highlight,
  highlightActions,
  tags,
  groups,
  filterTags
}) => ({
  uploadedImages,
  uploadedImagesPercentage,
  uploadedImagesPreview,
  productCategories,
  highlight,
  highlightActions,
  tags,
  groups,
  filterTags
});

export default connect(mapStateToProps, {
  fetchHighlight,
  updateHighlight,
  uploadImage,
  removeUploadedImage,
  setUploadedImagePreview,
  toggleFullPageSpinner,
  toggleNotification,
  fetchProductCategories,
  fetchTags,
  fetchFilterTags,
  fetchGroups,
  fetchHighlightActions
})(HighlightEdit);
